import React, { useMemo } from 'react';
import { Box, Typography, List, ListItem, ListItemButton, ListItemText } from '@mui/material';

import { useAuth } from '../../context/AuthContext';
import { ProcurementPOPermissions, ProcurementRFQPermissions } from '../../utils/permissions';

import {
  ProcurementPoTutorialVideo,
  ProcurementRfqTutorialVideo,
} from '../../config/tutorials';

const tutorialList = [
  {
    label: 'Procurement Purchase Order Tutorial (~10min)',
    url: ProcurementPoTutorialVideo,
    permissions: ProcurementPOPermissions,
  },
  {
    label: 'Procurement Request For Quote Tutorial (~10min)',
    url: ProcurementRfqTutorialVideo,
    permissions: ProcurementRFQPermissions,
  },
  // Add more tutorials here...
];

const Tutorials = () => {
  const { userPermissions } = useAuth();

  const userPermissionNames = useMemo(
    () => userPermissions?.map(p => p.name) || [],
    [userPermissions]
  );

  const visibleTutorials = tutorialList.filter((tutorial) =>
    tutorial.permissions.some((p) => userPermissionNames.includes(p))
  );
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '90vh',
        backgroundColor: '#f9f9f9',
        p: 2,
      }}
    >
      <Box
        sx={{
          maxWidth: 600,
          width: '100%',
          p: 4,
          border: '1px solid #ddd',
          borderRadius: '8px',
          boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
          backgroundColor: '#fafafa',
        }}
      >
        <Typography variant="h5" gutterBottom sx={{ textAlign: 'center', fontWeight: 'bold', color: '#1976d2' }}>
          Application Tutorials
        </Typography>

        <List>
          {visibleTutorials.length === 0 ? (
            <Typography sx={{ textAlign: 'center', mt: 2 }} color="textSecondary">
              No tutorials available for your role.
            </Typography>
          ) : (
            visibleTutorials.map((tutorial, idx) => (
              <ListItem key={idx} disablePadding>
                <ListItemButton component="a" href={tutorial.url} target="_blank" rel="noopener noreferrer">
                  <ListItemText primary={tutorial.label} />
                </ListItemButton>
              </ListItem>
            ))
          )}
        </List>
      </Box>
    </Box>
  );
};

export default Tutorials;
